import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface ExecuteParams {
  year: number;
  month: number;
  empFrom: string;
  empTo: string;
}

export interface ClosingItem {
  empCode: string;
  empName: string;
  leaveType: string;
  opening: number;
  taken: number;
  closing: number;
  adjustment: number;
}

export interface ExecuteResult {
  processed: number;
  results: ClosingItem[];
}

export interface ClosingStatus {
  lastYear: number;
  lastMonth: number;
  lastProcessed: number;
  lastRunAt: string;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Methods
// ============================================================

export const pw9614Api = {
  async execute(params: ExecuteParams): Promise<ExecuteResult> {
    const res = await apiClient.post('/api/pw9614/execute', params);
    return res.data;
  },

  async preview(params: ExecuteParams): Promise<ExecuteResult> {
    const res = await apiClient.post('/api/pw9614/preview', params);
    return res.data;
  },

  async getStatus(): Promise<ClosingStatus> {
    const res = await apiClient.get('/api/pw9614/status');
    return res.data;
  },
};

export default pw9614Api;
